(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  } else {
    root.ImpactSearch = api;
    api.init(root.document, root.location, root.history, root.fetch);
  }
}(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';

  var originalParameter = 'ia_original_q';
  var fallbackParameter = 'ia_fallback';
  var debounceMilliseconds = 150;
  var minimumDropdownCharacters = 3;

  function normaliseQuery(value) {
    return String(value || '').replace(/[^\s]+/g, function (token) {
      if (!/[A-Za-z]/.test(token) || !/[0-9]/.test(token)) return token;
      return token
        .replace(/([A-Za-z])(?=[0-9])|([0-9])(?=[A-Za-z])/g, '$& ')
        .replace(/(wp)(cl)\b/gi, '$1 $2');
    });
  }

  function escapeRegExp(value) {
    return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  function rankDropdownResults(query, results) {
    var items = Array.isArray(results) ? results.slice() : [];
    var model = normaliseQuery(query).trim().replace(/\s+/g, ' ');
    if (!/[A-Za-z]/.test(model) || !/[0-9]/.test(model) || !/^[A-Za-z0-9./-]+(?:\s+[A-Za-z0-9./-]+)*$/.test(model)) {
      return items;
    }

    var modelSource = model.split(' ').map(escapeRegExp).join('\\s+');
    var modelPrefix = new RegExp('^' + modelSource + '(?=$|[^A-Za-z0-9])', 'i');
    var modelAnywhere = new RegExp('(?:^|[^A-Za-z0-9])' + modelSource + '(?=$|[^A-Za-z0-9])', 'i');
    var accessoryTitle = /\b(?:protective|grilles?|gaskets?)\b/i;
    var relevantIndexes = [];
    var drivers = [];
    var accessories = [];

    items.forEach(function (item, index) {
      var title = normaliseQuery(String(item && item.title || '')).trim();
      var brandedTitle = title.replace(/^visaton\s+/i, '');
      var isVisaton = brandedTitle !== title || String(item && item.vendor || '').toLowerCase() === 'visaton';
      if (isVisaton && modelPrefix.test(brandedTitle) && !accessoryTitle.test(title)) {
        relevantIndexes.push(index);
        drivers.push(item);
      } else if (modelAnywhere.test(title) && accessoryTitle.test(title)) {
        relevantIndexes.push(index);
        accessories.push(item);
      }
    });

    drivers.concat(accessories).forEach(function (item, index) {
      items[relevantIndexes[index]] = item;
    });
    return items;
  }

  function searchAction(form, location) {
    return new URL(form.action, location.href);
  }

  function isSearchForm(form, location) {
    if (!form || !form.action) return false;
    return /\/search\/?$/.test(searchAction(form, location).pathname);
  }

  function buildJsonUrl(action, query, location) {
    var url = new URL(action, location.href);
    url.search = '';
    url.searchParams.set('type', 'product');
    url.searchParams.set('q', query);
    url.searchParams.set('view', 'json');
    return url.toString();
  }

  function buildResultsUrl(action, query, original, usedFallback, location) {
    var url = new URL(action, location.href);
    url.search = '';
    url.searchParams.set('type', 'product');
    url.searchParams.set('q', query);
    url.searchParams.set('options[prefix]', 'last');
    if (original && original !== query) url.searchParams.set(originalParameter, original);
    if (usedFallback) url.searchParams.set(fallbackParameter, '1');
    return url.toString();
  }

  function requestWithFallback(original, request, signal) {
    var normalised = normaliseQuery(original);
    return request(normalised, signal).then(function (data) {
      if (normalised === original || Number(data.results_count) > 0) {
        return { data: data, query: normalised, original: original, usedFallback: false };
      }
      return request(original, signal).then(function (fallbackData) {
        return { data: fallbackData, query: original, original: original, usedFallback: true };
      });
    });
  }

  function createLookupRunner(request, onResult, onError) {
    var sequence = 0;
    var controller = null;

    function cancel() {
      sequence += 1;
      if (controller) controller.abort();
      controller = null;
    }

    function run(original) {
      cancel();
      var runSequence = sequence;
      controller = typeof AbortController === 'function' ? new AbortController() : null;
      var signal = controller ? controller.signal : undefined;
      return requestWithFallback(original, request, signal).then(function (result) {
        if (runSequence === sequence) onResult(result);
        return result;
      }).catch(function (error) {
        if (runSequence === sequence && (!error || error.name !== 'AbortError')) onError(error);
      });
    }

    return { run: run, cancel: cancel };
  }

  function addOriginalField(form, original, normalised, document) {
    var field = form.querySelector('input[name="' + originalParameter + '"]');
    if (original === normalised) {
      if (field) field.remove();
      return;
    }
    if (!field) {
      field = document.createElement('input');
      field.type = 'hidden';
      field.name = originalParameter;
      form.appendChild(field);
    }
    field.value = original;
  }

  function bindSubmit(form, document) {
    form.addEventListener('submit', function () {
      var input = form.querySelector('input[name="q"]');
      if (!input) return;
      var original = input.value;
      var normalised = normaliseQuery(original);
      addOriginalField(form, original, normalised, document);
      input.value = normalised;
    });
  }

  function renderResults(list, result, form, document, location) {
    list.textContent = '';
    if (!result.data || Number(result.data.results_count) === 0) {
      list.hidden = true;
      return;
    }

    var partNumberLabel = form.getAttribute('data-impact-part-number-label') || 'Part number';
    rankDropdownResults(result.query, result.data.results).forEach(function (item) {
      var listItem = document.createElement('li');
      var link = document.createElement('a');
      var thumbnail = document.createElement('span');
      var image = document.createElement('img');
      var title = document.createElement('span');
      link.href = item.url;
      thumbnail.className = 'thumbnail';
      image.src = item.thumbnail;
      image.alt = '';
      title.className = 'title';
      title.textContent = item.title + (item.part_number ? ' · ' + partNumberLabel + ' ' + item.part_number : '');
      thumbnail.appendChild(image);
      link.appendChild(thumbnail);
      link.appendChild(title);
      listItem.appendChild(link);
      list.appendChild(listItem);
    });

    if (Number(result.data.results_count) > result.data.results.length) {
      var allItem = document.createElement('li');
      var allLink = document.createElement('a');
      var allTitle = document.createElement('span');
      allLink.href = buildResultsUrl(form.action, result.query, result.original, result.usedFallback, location);
      allTitle.className = 'title';
      allTitle.textContent = (form.getAttribute('data-impact-all-results-label') || 'Search') + ' (' + result.data.results_count + ')';
      allLink.appendChild(allTitle);
      allItem.appendChild(allLink);
      list.appendChild(allItem);
    }
    list.hidden = false;
  }

  function bindAutocomplete(form, document, location, fetch) {
    var input = form.querySelector('input[name="q"]');
    if (!input || typeof fetch !== 'function') return;
    form.style.position = 'relative';
    input.setAttribute('autocomplete', 'off');
    var list = form.querySelector('.search-results');
    if (!list) {
      list = document.createElement('ul');
      list.className = 'search-results';
      list.style.top = (input.offsetTop + input.offsetHeight + 7) + 'px';
      list.hidden = true;
      form.appendChild(list);
    }

    function request(query, signal) {
      return fetch(buildJsonUrl(form.action, query, location), {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
        signal: signal
      }).then(function (response) {
        if (!response.ok) throw new Error('Search request failed with status ' + response.status);
        return response.json();
      });
    }

    var runner = createLookupRunner(request, function (result) {
      renderResults(list, result, form, document, location);
    }, function () {
      list.hidden = true;
    });
    var timer = null;
    var lastTerm = null;

    function schedule() {
      var term = input.value;
      if (timer) clearTimeout(timer);
      runner.cancel();
      if (term.length < minimumDropdownCharacters) {
        lastTerm = term;
        list.hidden = true;
        return;
      }
      if (term === lastTerm) return;
      timer = setTimeout(function () {
        lastTerm = term;
        runner.run(term);
      }, debounceMilliseconds);
    }

    input.addEventListener('input', schedule);
    input.addEventListener('change', schedule);
  }

  function cleanTrackingParameters(url) {
    url.searchParams.delete(originalParameter);
    url.searchParams.delete(fallbackParameter);
    return url;
  }

  function handleSearchPage(document, location, history) {
    var page = document.querySelector('[data-impact-search-page]');
    if (!page) return;
    var url = new URL(location.href);
    var query = url.searchParams.get('q') || '';
    var original = url.searchParams.get(originalParameter);
    var usedFallback = url.searchParams.get(fallbackParameter) === '1';
    var resultsCount = Number(page.getAttribute('data-results-count') || 0);

    if (usedFallback) {
      if (history && history.replaceState) history.replaceState({}, '', cleanTrackingParameters(url).toString());
      return;
    }

    if (original !== null) {
      if (resultsCount === 0 && original !== query) {
        url.searchParams.set('q', original);
        url.searchParams.delete(originalParameter);
        url.searchParams.set(fallbackParameter, '1');
        location.replace(url.toString());
      } else if (history && history.replaceState) {
        history.replaceState({}, '', cleanTrackingParameters(url).toString());
      }
      return;
    }

    var normalised = normaliseQuery(query);
    if (query && normalised !== query) {
      url.searchParams.set('q', normalised);
      url.searchParams.set(originalParameter, query);
      location.replace(url.toString());
    }
  }

  function init(document, location, history, fetch) {
    handleSearchPage(document, location, history);
    var forms = Array.prototype.filter.call(document.querySelectorAll('form[action]'), function (form) {
      return isSearchForm(form, location);
    });
    forms.forEach(function (form) {
      bindSubmit(form, document);
      bindAutocomplete(form, document, location, fetch);
    });
    document.addEventListener('click', function (event) {
      forms.forEach(function (form) {
        if (!form.contains(event.target)) {
          var list = form.querySelector('.search-results');
          if (list) list.hidden = true;
        }
      });
    });
  }

  return {
    normaliseQuery: normaliseQuery,
    rankDropdownResults: rankDropdownResults,
    debounceMilliseconds: debounceMilliseconds,
    minimumDropdownCharacters: minimumDropdownCharacters,
    buildJsonUrl: buildJsonUrl,
    buildResultsUrl: buildResultsUrl,
    requestWithFallback: requestWithFallback,
    createLookupRunner: createLookupRunner,
    bindSubmit: bindSubmit,
    handleSearchPage: handleSearchPage,
    init: init
  };
}));
